import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onReject} from '../handler'
import {GameState} from './entities'
import {
  initAnsweredIdsThunk,
  addAnsweredIdThunk,
  initLCThunkFromSave,
  saveFromLCThunk,
} from './thunk'

const initialState: GameState = {
  answeredIds: [],
  progress: 0,
  isFullProgress: false,
  countRiddles: 0,
  showCongratulateModal: false,
  loadingGame: false,
}

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setAnsweredIds: (state, action: PayloadAction<string[]>) => {
      state.answeredIds = [...action.payload]
      if (state.answeredIds.length > 0 && state.countRiddles === state.answeredIds.length) {
        state.isFullProgress = true
      } else {
        state.isFullProgress = false
      }
      return state
    },
    addAnsweredId: (state, action: PayloadAction<string>) => {
      state.answeredIds.push(action.payload)
      if (state.answeredIds.length > 0 && state.countRiddles === state.answeredIds.length) {
        state.isFullProgress = true
      }
      return state
    },
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload
      return state
    },
    setCountRiddles: (state, action: PayloadAction<number>) => {
      state.countRiddles = action.payload
      if (state.countRiddles > 0 && state.countRiddles === state.answeredIds.length) {
        state.isFullProgress = true
      } else {
        state.isFullProgress = false
      }
      return state
    },
    setCongratuateModalWasShown: (state) => {
      state.showCongratulateModal = true
      return state
    },
    clearShowCongratulateModal: (state) => {
      state.showCongratulateModal = false
      return state
    },
    setLoadGame: (state) => {
      state.loadingGame = true
      return state
    },
    setGameLoaded: (state) => {
      state.loadingGame = false
      return state
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initAnsweredIdsThunk.fulfilled, (state) => {
      return state
    })
    builder.addCase(initAnsweredIdsThunk.rejected, (state, action) => {
      onReject(action.payload)
    })
    builder.addCase(addAnsweredIdThunk.fulfilled, (state) => {
      return state
    })
    builder.addCase(addAnsweredIdThunk.rejected, (state, action) => {
      onReject(action.payload)
    })
    builder.addCase(initLCThunkFromSave.fulfilled, (state) => {
      return state
    })
    builder.addCase(initLCThunkFromSave.rejected, (state, action) => {
      onReject(action.payload)
    })
    builder.addCase(saveFromLCThunk.fulfilled, (state) => {
      return state
    })
    builder.addCase(saveFromLCThunk.rejected, (state, action) => {
      onReject(action.payload)
    })
  },
})

export const {
  setAnsweredIds,
  addAnsweredId,
  setProgress,
  setCountRiddles,
  setCongratuateModalWasShown,
  clearShowCongratulateModal,
  setLoadGame,
  setGameLoaded,
} = gameSlice.actions

export default gameSlice.reducer
